import React, { ComponentType, PureComponent } from 'react';
import { Track, TrackingData } from '@justgiving/react-tracking';

import { captureException } from '@sentry/react';

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;
type Subtract<T, K> = Omit<T, keyof K>;

const analytics = {
  track: (trackingData: TrackingData) => {
    const { action_name: actionName, ...actionData } = trackingData;
    try {
      if (window && window.gtag) {
        window.gtag('event', actionName || 'action', actionData);
      }
    } catch (error) {
      captureException(error);
    }
  },
};

export interface WithTrack {
  track: (data: TrackingData) => void;
}

export const withTrack = <P extends WithTrack>(
  WrappedComponent: ComponentType<P>,
) =>
  class extends PureComponent<Subtract<P, WithTrack>> {
    render() {
      return (
        <Track>
          {(track) => <WrappedComponent {...(this.props as P)} track={track} />}
        </Track>
      );
    }
  };

export default analytics;
